import { getFileRequest, getRequest, postRequest } from '../../../api/api';

export function postRetrieveInvestmentNoteDetails(values, callbackResponse) {
    return postRequest(
        'api/v1',
        null,
        values,
        callbackResponse,
    );
};

export function getDownloadInvestmentMemo(values) {
    return getFileRequest(
        `api/v1/investment/investment-memo`,
        values,
        'investment-memo',
    );
};

export function getComments(investmentNoteId, callbackResponse) {
    return getRequest(
        'api/v1/comment/list?investment_note_id=' + investmentNoteId,
        null,
        callbackResponse,
    );
};

export function postSubmitComment(values, callbackResponse) {
    return postRequest(
        'api/v1/comment/save',
        null,
        values,
        callbackResponse,
    );
};

export function postDeleteComment(values, callbackResponse) {
    return postRequest(
        'api/v1/comment/delete',
        null,
        values,
        callbackResponse,
    );
};